import { AsyncStoreItem } from '@lib';
import { PostStandbyCompleteEntryResponse } from 'src/sdk_checkin';

/**
 * StandbyEntryCompletionResult model
 */
export interface StandbyEntryCompletionResultModel {
  model: PostStandbyCompleteEntryResponse | null;
}

/**
 * PostStandbyEntryCompletionResponse model details
 */
export interface StandbyEntryCompletionResultStateDetails extends AsyncStoreItem {}

/**
 * StandbyEntryCompletionResult store state
 */
export interface StandbyEntryCompletionResultState
  extends StandbyEntryCompletionResultStateDetails,
    StandbyEntryCompletionResultModel {}

/**
 * Name of the StandbyEntryCompletionResult Store
 */
export const STANDBY_ENTRY_COMPLETION_RESULT_STORE_NAME = 'standbyEntryCompletionResult';

/**
 * StandbyEntryCompletionResult Store Interface
 */
export interface StandbyEntryCompletionResultStore {
  /** StandbyEntryCompletionResult state */
  [STANDBY_ENTRY_COMPLETION_RESULT_STORE_NAME]: StandbyEntryCompletionResultState;
}
